import { render, staticRenderFns } from "./NewsArticle.vue?vue&type=template&id=1024fe4b&"
import script from "./NewsArticle.vue?vue&type=script&lang=ts&"
export * from "./NewsArticle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports